import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state'
import { Prop, Watch } from 'vue-property-decorator'
import Konva from 'konva'
import { colorTorgba, fontNameEn } from '../../utils/utils'
import { saveSrtParamsStyle } from '../../utils/srtParamsStyle'
import { getFontDeviation } from '../../utils/constant'

@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class Subtitles extends Vue {
  state = new PageState()
  @Prop({default: () => {}})
  subtitleInfo: any
  @Prop({default: () => []})
  imgList: Array<any>
  @Prop({default: ''})
  subtitles: string
  @Prop({default: false})
  isEdit: boolean
  @Prop({default: 'subtitle-canvas', required: false})
  subtitlesId: string
  @Prop({default: ''})
  source: string
  @Prop({default: () => [], required: false})
  textList: Array<any>
  startY = 0
  distanceY = 0
  offsetTop = 0

  startX = 0
  distanceX = 0
  offsetLeft = 0

  player: HTMLElement = null
  subtitleWrapper: HTMLElement = null
  subtitle: HTMLElement = null
  isInit = true
  startScaleTouchX = 0
  startScaleTouchY = 0
  // 缩放
  scaleValue = 1
  fontSize = 16
  isShowEdit = false
  get marginV(){
    return this.subtitleInfo.marginV * 100 + '%'
  }
  get marginL() {
    return this.subtitleInfo.marginL * 100 + '%'
  }
  isSubtitleInfo = false // 是否字幕信息更改重新变化位置
  subtitleCanvasRef = null
  subtitleWidth = 0
  subtitleHeight = 0
  initFontPercent = 8
  subtitleRatio = 1
  top: number = 0
  isTouchEnd = false
  stage:Konva.Stage = null
  layer: Konva.Layer = null
  simpleText: Konva.Text
  currentTextIndex = null
  subtitleDomList: any = []
  loadFontFamilyFunc: any
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  @Watch('subtitles')
  listenSubtitles(val, oldVal) {
    if (!val && oldVal) {
      this.isShowEdit = false
    } else if (val && !oldVal && !this.isInit) {
      this.isShowEdit = true
    }
    this.isInit = false
    this.drawText('edit')
  }
  @Watch('subtitleInfo', {deep: true})
  listenSubtitleInfo(val, oldVal) {
    this.$nextTick(() => {
      this.loadFontFamilyFunc = this.drawText()
    })
    
  }
  @Watch('isEdit')
  listenIsEdit(val) {
    this.isShowEdit = val
  }
  @Watch('textList', {deep: true})
  listenTextList(val, oldVal) {
    this.$nextTick(() => {
      this.loadFontFamilyFunc = this.drawText('edit')
    })
  }
  /**
   * 处理背景色
   */
  get bgColor() {
    const bgColor = this.subtitleInfo.bgColor
    return this.hexToRgb(bgColor)
  }
  get subtitlesTextList() {
    const textList = this.subtitles.split('\n')
    return textList
  }
  mounted() {
    window.addEventListener('resize', this.onWindowResize)
    setTimeout(() => {
      this.initLayout()
    }, 300)
  }
  onWindowResize() {
    this.initLayout()
  }
  initLayout() {
    this.subtitleWrapper = this.$refs.subtitleWrapperRef as HTMLElement;
    this.player = this.subtitleWrapper.parentElement
    if (this.source !== 'cover' && this.$refs.subtitleRef) {
      this.subtitle = this.$refs.subtitleRef as HTMLElement
      this.offsetTop = this.subtitle.offsetTop
    }
    
    this.subtitleCanvasRef = document.getElementById(this.subtitlesId) as HTMLElement
    const width = this.subtitleCanvasRef.clientWidth
    const height = this.subtitleCanvasRef.clientHeight
    console.log('subtitleCanvasRef', width)
    if (this.stage) {
      this.stage.destroy()
      this.stage = null
    }
    this.stage = new Konva.Stage({
      container: this.subtitlesId,   // id of container <div>
      width: width,
      height: height
    })
    this.layer = new Konva.Layer()
    this.top = height - 40
    this.drawText('init')
    this.$bus.$on('download-fontFamily', () => {
      if (this.loadFontFamilyFunc) {
        this.loadFontFamilyFunc.callback(this.loadFontFamilyFunc.params)
        this.loadFontFamilyFunc = null
      }
    })
  }
  drawText(type?: string) {
    if (!this.stage)return
    this.layer && this.layer.destroy()
    if (this.source === 'cover') {
      this.textList.forEach((item, index) => {
        const textInfo = this.getText({
          ...item,
          scaleVector2d: {
            x: this.scaleValue,
            y: this.scaleValue
          },
        }, type, index)
        this.layer.add(textInfo)
      })
    } else {
      const textInfo = {
        ...this.subtitleInfo,
        text: this.subtitles,
        scaleVector2d: {
          x: this.scaleValue,
          y: this.scaleValue
        },
        marginV: this.subtitleInfo.marginV,
        marginL: this.subtitleInfo.marginL,
        isInit: type === 'init'
      }
      const simpleText = this.getText(textInfo, type, 0)

      this.layer.add(simpleText);
    }
   
    this.stage.add(this.layer)
    return {
      callback: this.drawText,
      params: type
    }
  }
  /**
   * 绘制文字
   * @param textInfo
   * @param y 
   * @returns 
   */
  getText(textInfo, type, index) {
    console.log('getText', textInfo)
    let marginV = 0
    let marginL = 0
    if (this.source === 'cover') {
      marginV = textInfo.yRatio
      marginL = textInfo.xRatio
      const domList = document.getElementsByClassName('cover_subtitle')
      this.subtitleDomList = domList
    } else {
      marginV = textInfo.marginV
      marginL = textInfo.marginL
    }

    const canvasHeight = this.stage.height()
    const canvasWidth = this.stage.width()
    let y = canvasHeight - canvasHeight * marginV
    if (this.source === 'cover') {
      y = canvasHeight * marginV
    }
   
    const x = canvasWidth * marginL
    let text = textInfo.text.trim()
    const fontSize = Math.floor(canvasHeight * textInfo.fontPercent / 100) - getFontDeviation(canvasWidth)
    const konvaText = new Konva.Text({
      x: x,
      y: y,
      text: text,
      fontSize,
      fill: colorTorgba(textInfo.fontColour, textInfo.alpha),
      stroke: colorTorgba(textInfo.fontStrokeColor, textInfo.alpha),
      strokeWidth: 3,
      fillAfterStrokeEnabled: true,
      align: 'center',
      wrap: 'none',
      // lineHeight: 1.2,
      letterSpacing: 3,
      scale: textInfo.scaleVector2d,
      sceneFunc: (context, shape) => {
        if (textInfo.bgMode === 'none') {
          (shape as Konva.Text)._sceneFunc(context);
          return
        }
        if (this.source !== 'cover') {
           context.fillStyle = colorTorgba(textInfo.bgColor, textInfo.bgAlpha);
          context.fillRect(0,0,shape.width(),shape.height());
        }
       
        (shape as Konva.Text)._sceneFunc(context);
      },
    })
    
    const textWidth = konvaText.width()
    if (textInfo.isInit && this.source === 'cover') {
      konvaText.setAttrs({
        x: canvasWidth / 2 - textWidth / 2
      })
      this.$emit('update-textInfo', konvaText.x() / canvasWidth, index)
    } else {
      if (this.source !== 'cover') {
        konvaText.offsetX(textWidth/2)
      }
    }
   
   

    if (textInfo.fontFamily) {
      konvaText.fontFamily(fontNameEn(textInfo.fontFamily))
    }
    if (type !== 'drag' && type !== 'scale') {
      // 设置边框距离
      const textBoxWidth = Math.min(textWidth, canvasWidth)
      const _substitleRef = document.getElementsByClassName('cover_subtitle')[index] as HTMLElement;
      let width = (textBoxWidth + 10) * textInfo.scaleVector2d.x
      if (width > this.player.clientWidth) {
        width = this.player.clientWidth
      }
      if (this.source === 'cover') {
        _substitleRef.style.width = width + 'px'
        _substitleRef.style.height = (konvaText.height() + 10)  * textInfo.scaleVector2d.x + 'px'
        _substitleRef.style.left = (konvaText.x() / canvasWidth - 4 / canvasWidth) * 100 + '%'
        _substitleRef.style.top = konvaText.y() / canvasHeight * 100 + '%'
      } else {

        this.subtitle.style.width = width + 'px'
        this.subtitle.style.height = (konvaText.height() + 10)  * textInfo.scaleVector2d.x + 'px'
        // this.subtitle.style.left = (konvaText.x() / canvasWidth - 4 / canvasWidth) * 100 + '%'
      }
    }
   if (this.source === 'cover') {
    konvaText.offsetY(-5)
   } else {
    konvaText.offsetY(konvaText.height() + 4)
   }
   
   konvaText.on('tap', (evt) => {
     this.currentTextIndex = index
     this.subtitleEdit(index)
   })
    return konvaText
  }
  bgColorAlpha(alpha){
    const color = this.bgColor.replace('rgb', 'rgba').replace(')', `, ${alpha}`)
    return color
  }
  onTouchStart(event) {
    const touchInfo = event.targetTouches[0]
    this.startY = touchInfo.pageY
    this.startX = touchInfo.pageX
    if (this.source === 'cover') {
      const subtitleDom = this.subtitleDomList[this.currentTextIndex]
      this.offsetTop = subtitleDom.offsetTop
      this.offsetLeft = subtitleDom.offsetLeft
    } else {
      this.offsetTop = this.subtitle.offsetTop
      this.offsetLeft = this.subtitle.offsetLeft
    }
    
    this.isTouchEnd = false
  }
  // 获取自身起始信息
  getInfo(e) {
    if (this.source === 'cover') {
      const subtitleDom = this.subtitleDomList[this.currentTextIndex]
      this.subtitleWidth = subtitleDom.clientWidth
      this.subtitleHeight = subtitleDom.clientHeight
    } else {
      this.subtitleWidth = this.subtitle.clientWidth
      this.subtitleHeight = this.subtitle.clientHeight
    }
    
    this.startScaleTouchX = e.clientX
    this.startScaleTouchY = e.clientY

    this.subtitleRatio = this.subtitleWidth / this.subtitleHeight

  }

  /**
   * 缩放按钮touch start
   * @param event
   */
  onScaleTouchStart(event, index) {
    if (this.source === 'cover') {
      this.subtitleEdit(index)
    }
    
    const touchInfo = event.targetTouches[0]
    this.startScaleTouchX = touchInfo.pageX
    this.startScaleTouchY = touchInfo.pageY
    this.getInfo(touchInfo)

    this.scaleValue = 1
    if(this.source === 'cover'){
      this.initFontPercent = this.textList[this.currentTextIndex].fontPercent
    } else {
      this.initFontPercent = this.subtitleInfo.fontPercent
    }
  }
  /**
   * 缩放按钮移动事件
   * @param event
   */
  onScaleTouchMove(event) {
    const touchInfo = event.targetTouches[0]
    const newWidth = this.subtitleWidth + (touchInfo.clientX - this.startScaleTouchX)
    let width = newWidth !== undefined ? newWidth : this.subtitleWidth
    const { clientWidth, clientHeight } = this.subtitleCanvasRef
    if (width > clientWidth) {
      width = clientWidth
    }
    const minFontSize = clientHeight * 1 / 100
    if (width < minFontSize) {
      // 字号为1时的最小宽度
      width = minFontSize
    }
    if (this.source === 'cover') {
      this.scaleValue = width / this.subtitleWidth
      console.log('onScaleTouchMove', this.currentTextIndex)
      const _substitleRef = document.getElementsByClassName('cover_subtitle')?.[this.currentTextIndex] as HTMLElement
      if (_substitleRef) {
        _substitleRef.style.width = width + 'px'
        _substitleRef.style.height = width / this.subtitleRatio + 'px'
      }
      const newTextItem = this.textList[this.currentTextIndex]
      // this.$bus.$emit('input-subtitle', newTextItem, this.currentTextIndex)
      // this.$emit('editor-subtitle', newTextItem, this.currentTextIndex)
    } else {
      this.scaleValue = width / this.subtitleWidth
      this.subtitle.style.width = width + 'px' 
      this.subtitle.style.height = width / this.subtitleRatio + 'px'
      this.drawText('scale')
    }

  }
  onScaleTouchEnd() {
    const newFont = Math.min(16, Math.max(1, +(this.scaleValue * this.initFontPercent).toFixed(1)))
    this.scaleValue = 1
    if (this.source === 'cover') {
      const newTextItem = {...this.textList[this.currentTextIndex], fontPercent: newFont}
      this.$bus.$emit('input-subtitle', newTextItem, this.currentTextIndex)
      this.$emit('editor-subtitle', newTextItem, this.currentTextIndex)
    } else {
      this.state.subtitleInfo.fontPercent = newFont
    }
  }
  /**
   * 拖动移动位置
   * @param event
   */
  onTouchMove(event) {
    const touchInfo = event.targetTouches[0]
    const pageY = touchInfo.pageY
    const pageX = touchInfo.pageX
    this.distanceY = pageY - this.startY
    this.distanceX = pageX - this.startX
    this.setLayout()
  }
  onTouchEnd() {
    if (this.source === 'cover') {
      this.$emit('editor-subtitle', this.textList[this.currentTextIndex], this.currentTextIndex)
    } else {
      this.isTouchEnd = true
    }
    
  }
  /**
   * 设置left, top
   */
  setLayout() {
   
    let _top = this.offsetTop + this.distanceY
    let _left = this.offsetLeft + this.distanceX
    if (this.source === 'cover') {
      const subtitleDom = this.subtitleDomList[this.currentTextIndex]
      if ((_top >= this.subtitleCanvasRef.clientHeight - subtitleDom.clientHeight) || 
      (_top +  subtitleDom.clientHeight >=  this.subtitleCanvasRef.clientHeight)) {
        _top = this.subtitleCanvasRef.clientHeight - subtitleDom.clientHeight
      } else if (_top <= 0) {
        _top = 0
      }
      this.top = _top
      const bottom =  this.subtitleCanvasRef.clientHeight - _top - subtitleDom.clientHeight
      const ratio = bottom /  this.subtitleCanvasRef.clientHeight
      const yRatio = _top / this.subtitleCanvasRef.clientHeight
      const xRatio = _left / this.subtitleCanvasRef.clientWidth
      this.$bus.$emit('input-subtitle', {
        ...this.textList[this.currentTextIndex], 
        marginV: ratio, 
        yRatio, 
        xRatio,
        isDrag: true
      }, this.currentTextIndex)
    } else {
      if ((_top >= this.subtitleCanvasRef.clientHeight - this.subtitle.clientHeight) || 
      (_top +  this.subtitle.clientHeight >=  this.subtitleCanvasRef.clientHeight)) {
        _top = this.subtitleCanvasRef.clientHeight - this.subtitle.clientHeight
      } else if (_top <= 0) {
        _top = 0
      }
      this.top = _top
      const bottom =  this.subtitleCanvasRef.clientHeight - _top - this.subtitle.clientHeight
      const ratio = bottom /  this.subtitleCanvasRef.clientHeight
      const xRatio = _left / this.subtitleCanvasRef.clientWidth
      this.state.subtitleInfo.marginV = ratio
      this.state.subtitleInfo.marginL = 0.5
      saveSrtParamsStyle({
        marginV: ratio,
        marginL: 0.5
      })
      this.drawText('drag')
    }
    
    
    // 
  }
  /**
   * 删除该字幕
   * @param index
   */
  delSubtitle(index) {
    this.$emit('del-subtitle', index)
  }
  subtitleEdit(index) {
    if (this.source === 'cover') {
      this.currentTextIndex = index || 0
      this.$bus.$emit('input-subtitle', {...this.textList[this.currentTextIndex], showBorder: true}, this.currentTextIndex)
    } else {
      this.isShowEdit = true
    }
   
    this.$emit('editor-subtitle',this.textList[this.currentTextIndex], this.currentTextIndex)
  }
  /**
   * 16进制转rgba
   * @param hex
   * @returns 
   */
  hexToRgb(hex) {
    let str = hex.replace("#", "");
    if (str.length % 3) {
      return "hex格式不正确！";
    }
    //获取截取的字符长度
    let count = str.length / 3;
    //根据字符串的长度判断是否需要 进行幂次方
    let power = 6 / str.length;
    let r = parseInt("0x" + str.substring(0 * count, 1 * count)) ** power;
    let g = parseInt("0x" + str.substring(1 * count, 2 * count)) ** power;
    let b = parseInt("0x" + str.substring(2 * count)) ** power;

    return `rgb(${r}, ${g}, ${b})`;
  }
}
